import { fetchPost } from './fetch'
export function isActive(history) {
    const arr = ['', 'register','forgetPassword']
    //some() 方法用于检测数组中的元素是否满足指定条件,如果有一个元素满足条件，则表达式返回true , 剩余的元素不会再执行检测。
    // 如果没有满足条件的元素，则返回false。
    const result = arr.some(function(item) {
        return window.location.href.indexOf(item) > 0
    })
    // result 表示当前页面可能是登录或者注册或者忘记密码页面
    // 不是登录页面 ，不是注册页面才会去检测用户的活跃状态（鼠标移动状态）
    if (!result)
    {
        let lastTime = new Date().getTime();
        let currentTime = new Date().getTime();
        //设置超时时间： 90分
        const timeOut = 90 * 60 * 1000;

        /* 检测鼠标移动事件 */
        document.addEventListener('mousemove',function () {
            // 更新最后的操作时间
            //console.log('鼠标移动了')
            lastTime = new Date().getTime();
        })
        /* 定时器  间隔2分钟检查一次，检测是否长时间未操作页面  */
        const quitTime = window.setInterval(testTime, 120000);
        //setInterval() 方法会不停地调用函数，直到 clearInterval() 被调用或窗口被关闭。

        // 超时函数
        function testTime() {
            //更新当前时间
            // console.log(lastTime)
            currentTime = new Date().getTime();
            // console.log('currentTime', currentTime)
            //判断是否超时
            if (currentTime - lastTime > timeOut) {
                 // console.log('超时了')

                // 清除掉定时器
                window.clearInterval(quitTime)
                //自动登出
                fetchPost(global.constants.logout,{})
                    .then(
                        res =>{
                            if(res.code === 200){
                                localStorage.setItem("userId",res.code)
                                localStorage.removeItem("username")
                                localStorage.removeItem("companyName")
                                localStorage.removeItem("companyId")
                                localStorage.removeItem("area")
                                localStorage.removeItem("identity")
                            }
                        }
                    )
                history.replace('/');
                alert('您长时间未操作，请重新登录')
            }
        }
    }
}